import type { FaireProductEntity } from "../../entity_types/product";

export const p_7n4wgwpf6d: FaireProductEntity = {
  token: "p_7n4wgwpf6d",
  type: "product",
  name: "Playkidz Shape Sorter Baby and Toddler Toy",
  brandToken: "b_dgh2zs2cwg",
  brandName: "The Toy Group",
  imageUrl: "https://cdn.faire.com/fastly/2e728067e9841637a81a6bfe9f64a80ee08225a247e00aeeb9133d7ae231d25d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3e16fab64528a6f2d10b044a2e828f9a71a172cf3040cab56964127b2b88ead2.jpeg",
    "https://cdn.faire.com/fastly/197b1ab8786fe1dc347388713323185765ec851eb6fa9b35c1c6ebfa0ef8b525.jpeg",
    "https://cdn.faire.com/fastly/5b46a3c709c148180ec0646f2c072fa8cf85a75bf662eefdcca0fd0a276969cd.jpeg",
    "https://cdn.faire.com/fastly/1f4910fb0c27d9b204596b1249b21ffc00a702289ad5bf3ba413447a9e2add1f.jpeg",
    "https://cdn.faire.com/fastly/5849ab35d5e7c28d780caeb8e060dc409698ce6fa03cf549a86305206b3895cc.jpeg",
    "https://cdn.faire.com/fastly/43cd4f9ca906c101dd83ea8c97b7db6b954e6f6abcc4631068abad25b3c9b1b8.jpeg"
  ],
  priceDollars: 5,
  description: "Playkidiz ultimate shape sorter features vibrant colored ABCs and shapes that make a satisfying clunk as they drop into their matching hole! A classic educational toy for children ages 18months+. It will improve baby's ability of observation, memory, imagination and thinking! This matching shape sorters game has a nostalgic feel and appeal.\n\nEach shape is designed to fit through its matching hole on the cover of the container. Start introducing your little one to ABCs and shapes. Its never too early!\n\nPlaying with this shape sorting toy will enhance children's fine motor skills and touch sense. Toy designed with bright kid friendly colors. Help your child learn the name of each color and differentiate between them. Children will learn how to interact with others, because playing together is a lot more amusing!\n\nThis Set Includes:\n• 16 x Shapes and ABCs\n• 1 x Carry/Storage Bucket\n\nClassic Activity: Improve babies ability of observation, memory, imagination and thinking! Playing",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:57.809Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
